//////////////////////////////////////////
// REPORT

import { Table } from '@absolute/cloud-notify';
import { head } from 'lodash-es';

//////////////////////////////////////////
const callBaseDiffDataStyle = 'width: 100%; font-size: 0.875rem;';
const tableStyle = 'border: 1px solid #ccc;';
const borderTableStyle = `${tableStyle} border-collapse: collapse;`;
const maxWidthTableStyle = `max-width: 800px;`;
const cellStyle = 'padding: 0.5rem;';
const headerCellStyle = `${cellStyle} background-color: #f3f4f6; font-weight: 600;`;
const fullWidthCellStyle = `${cellStyle} width: 100%;`;
const halfWidthCellStyle = `${cellStyle} width: 50%;`;
const thirdWidthCellStyle = `${cellStyle} width: 33%;`;
const templateDataStyle = `${cellStyle}`;
const trStyle = `padding: 0.5rem;`;
const templateColspan = 6;

export default function getReport(diff, options) {
    const arrayEntries = Object.entries(diff)
        .filter(([key, value]) => Array.isArray(value))
        .map(([key, value]) => {
            const renderedModel = renderDiffModel(key, value, { diff, ...options });
            return `<tr>${renderedModel}</tr>`;
        });

    const nonArrayEntries = Object.entries(diff)
        .filter(([key, value]) => !Array.isArray(value))
        .map(([key, value]) => {
            const renderedModel = renderDiffModel(key, value, { diff, ...options });
            return `<tr>${renderedModel}</tr>`;
        });

    return `
            <table style="width: 100%;">
                <thead style="max-height: 0px;">
                    <tr>
                        <th style="width: 20%;"></th>
                        <th style="width: 40%;"></th>
                        <th style="width: 40%;"></th>
                    </tr>
                </thead>
                <tbody>
                ${
                    nonArrayEntries.length > 0
                        ? `<td colspan="3" style="font-weight: 600; padding-bottom: 0.5rem; border: none;">
                ${_t.mail.fields.itinerary()}
                </td>
                <tr style="${trStyle} border: none; width: 100%;">
                <td colspan="3" style="${fullWidthCellStyle} border: none;">
                <table style=" width: 100%;">
                ${nonArrayEntries.join('')}
                </table>
                </td>
                </tr>`
                        : ''
                }
                ${arrayEntries.join('')}
                </tbody>
            </table>`;
    // <style>
    // td {
    //     border: 1px solid #ccc;
    // }
    // </style>`;
}

function renderDiffModel(key, value, options) {
    if (Array.isArray(value)) {
        return renderArray(key, value, options);
    }
    return renderRow(key, value, options);
}

function renderArray(key, arr, options) {
    switch (key) {
        case 'days':
            return renderDays(arr, options);
        case 'rooms':
            return renderRooms(arr);
        case 'gallery':
            return renderGallery(arr);
        case 'documents':
            return renderDocuments(arr, options);
        case 'places':
            return renderPlaces(arr, options);
        default:
            return '';
    }
}

function renderRow(key, diffValue, options) {
    const oldValue = diffValue?.oldValue;
    const newValue = diffValue?.newValue;

    const isObjectOldValue = oldValue && typeof oldValue === 'object' && oldValue !== null;
    const isObjectNewValue = newValue && typeof newValue === 'object' && newValue !== null;

    if (isObjectOldValue || isObjectNewValue) return renderObject(key, diffValue);

    if (!oldValue) {
        return `
            <tr style="${trStyle}">
                <td style="${headerCellStyle} width: 20%;">
                    ${_t.mail.fields[key]()}
                </td>
                <td colspan="2" style="${fullWidthCellStyle}">
                    <p style="font-weight: bold; color: #2563eb;">${_t.diff.added()}</p>
                    <p style="word-break: break-word;">${newValue}</p>
                </td>
            </tr>
        `;
    }
    if (!newValue) {
        return `
            <tr style="${trStyle}">
                <td style="${headerCellStyle} width: 20%;">
                    ${_t.mail.fields[key]()}
                </td>
                <td colspan="2" style="${fullWidthCellStyle}">
                    <p style="font-weight: bold; color: #dc2626;">${_t.diff.removed()}</p>
                    <p style="word-break: break-word;">${oldValue}</p>
                </td>
            </tr>
        `;
    }
    if (key === 'activeProfile') {
        const oldProfileName = options.itineraryOptions.find((el) => el.id === oldValue).name;
        const newProfileName = options.itineraryOptions.find((el) => el.id === newValue).name;
        return `
            <tr style="${trStyle}">
                <td style="${headerCellStyle} width: 20%;">
                    ${_t.mail.fields[key]()}
                </td>
                <td style="${cellStyle} width: 40%;">
                    ${oldProfileName}
                </td>
                <td style="${cellStyle}">
                    ${newProfileName}
                </td>
            </tr>
        `;
    }
    return `
        <tr style="${trStyle}">
            <td style="${headerCellStyle} width: 20%;">
                ${_t.mail.fields[key]()}
            </td>
            <td style="${cellStyle} width: 40%;">
                ${oldValue}
            </td>
            <td style="${cellStyle}">
                ${newValue}
            </td>
        </tr>
    `;
}

function renderObject(key, diffValue) {
    const oldValue = diffValue?.oldValue;
    const newValue = diffValue?.newValue;

    if (!oldValue) {
        return `
            <tr style="${trStyle}">
                <td style="${headerCellStyle} width: 20%;">
                    ${_t.mail.fields[key]()}
                </td>
                <td colspan="2" style="${fullWidthCellStyle}">
                    <p style="font-weight: bold; color: #2563eb;">${_t.diff.added()}</p>
                    ${key === 'jingle' ? renderAudio(newValue) : renderImage(newValue)}
                </td>
            </tr>
        `;
    }
    if (!newValue) {
        return `
            <tr style="${trStyle}">
                <td style="${headerCellStyle} width: 20%;">
                    ${_t.mail.fields[key]()}
                </td>
                <td colspan="2" style="${fullWidthCellStyle}">
                    <p style="font-weight: bold; color: #dc2626;">${_t.diff.removed()}</p>
                    ${key === 'jingle' ? renderAudio(oldValue) : renderImage(oldValue)}
                </td>
            </tr>
        `;
    }

    return `
        <tr style="${trStyle}">
            <td style="${headerCellStyle} width: 20%;">
                ${_t.mail.fields[key]()}
            </td>
            <td style="${cellStyle} width: 40%;">
                ${key === 'jingle' ? renderAudio(oldValue) : renderImage(oldValue)}
            </td>
            <td style="${cellStyle} width: 40%;">
                ${key === 'jingle' ? renderAudio(newValue) : renderImage(newValue)}
            </td>
        </tr>
    `;
}

function renderImage(image) {
    return `
        <img src="${image.src}" style="max-width: 300px; max-height: 300px; aspect-ratio: 16/9; object-fit: cover;" />
    `;
}

function renderAudio(audio) {
    return `<audio src="${audio.src}" controls></audio>`;
}

function renderDays(arr, options) {
    const entries = arr.map((diffValue) => {
        const oldValue = diffValue.oldValue;
        const newValue = diffValue.newValue;
        if (!oldValue && !newValue) {
            const arrayEntries = Object.entries(diffValue)
                .filter(([key, val]) => Array.isArray(val))
                .map(
                    ([key, val]) => `
                                    <tr style="width: 100%; padding: 0px;">
                                        <td colspan="3" style="width: 100%; padding: 0px;">
                                        ${renderArray(key, val, options)}
                                        </td>
                                    </tr>`
                );

            const nonArrayEntries = Object.entries(diffValue)
                .filter(([key, val]) => !Array.isArray(val))
                .map(([key, val]) => {
                    if (key.startsWith('_')) return '';
                    if (key === 'day') {
                        return `
                                    <tr style="${trStyle}">
                                        <td colspan="3" style="${fullWidthCellStyle}">
                                            ${_t.mail.movedFromDay()} ${val.oldValue + 1} ${_t.mail.movedToDay()} ${
                            val.newValue + 1
                        }
                                        </td>
                                    </tr>
                                `;
                    }
                    if (key === 'dayOrder') {
                        return `
                                    <tr style="${trStyle}">
                                        <td colspan="3" style="${fullWidthCellStyle}">
                                            ${_t.mail.movedFromPos()} ${val.oldValue + 1} ${_t.mail.movedToPos()} ${
                            val.newValue + 1
                        }
                                        </td>
                                    </tr>
                                `;
                    }
                    return renderRow(key, val, options);
                });

            return `
                    <tr style="width: 100%; border: none;">
                    <td colspan="3" style="border: none;">
                    <table style="${borderTableStyle} width: 100%;">
                    <tr style="padding-bottom: 1rem;">
                    <td colspan="3" style="${trStyle} background-color: #e5e7eb; font-weight: 600;">
                    ${diffValue?._name}
                    </td>
                    </tr>
                    <tr>
                    ${nonArrayEntries.join('')}
                    </tr>
                    ${arrayEntries.join('')}
                    </table>
                    </td>
                    </tr>
                `;
        }
        if (!oldValue) {
            const htmlString = generatePlanTemplateHtml(newValue);
            return `
                <tr style="width: 100%; border: none;">
                    <td colspan="3" style="border: none;">
                        <table style="${borderTableStyle} width: 100%;">
                            <tr style="background-color: #f3f4f6;">
                                <td style="background-color: #e5e7eb; padding: 0.5rem 1rem; font-weight: bold;">
                                    ${_t.mail.addedInDay()} ${diffValue._day + 1}
                                </td>
                            </tr>
                            <tr style="width: 100%;">
                                <td colspan="3" style="padding: 0px;">${htmlString}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            `;
        }
        if (!newValue) {
            return `
                <tr style="width: 100% border: none;">
                    <td colspan="3" style="border: none;">
                        <table style="${borderTableStyle} width: 100%;">
                            <tr style="background-color: #f3f4f6;">
                                <td colspan="3" style="background-color: #e5e7eb; padding: 0.5rem 1rem; font-weight: bold;">
                                    ${_t.mail.removedFromDay()} ${oldValue._day + 1}
                                </td>
                            </tr>
                            <tr style="width: 100%;">
                                <td style="padding: 0.5rem; background-color: #f3f4f6; font-weight: 600; width: 20%;">${_t.mail.fields.title()}</td>
                                <td colspan="2" style="padding: 0.5rem;">${oldValue._name}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            `;
        }
    });

    return `
        <td colspan="3" style="font-weight: 600; padding-bottom: 0.5rem; border: none;">
            ${_t.mail.fields.plans()}
        </td>
        ${entries.join('')}
    `;
}

function renderGallery(arr) {
    const entries = arr.map((diffValue) => {
        const oldValue = diffValue.oldValue;
        const newValue = diffValue.newValue;
        if (!oldValue && !newValue) return '';
        if (!oldValue) {
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #2563eb;">${_t.diff.added()}</p>
                        <img src="${newValue.src}" style="width: 200px; aspect-ratio: 16/9; object-fit: cover;" />
                    </td>
                </tr>
            `;
        }
        if (!newValue) {
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #dc2626;">${_t.diff.removed()}</p>
                        <img src="${oldValue.src}" style="width: 200px; aspect-ratio: 16/9; object-fit: cover;" />
                    </td>
                </tr>
            `;
        }
    });

    return `
        <table style="width: 100%;">
            <tr>
                <td colspan="3" style="padding: 0.5rem; background-color: #f3f4f6; font-weight: 600;">
                    ${_t.mail.fields.gallery()}
                </td>
            </tr>
            ${entries.join('')}
        </table>
    `;
}

function renderRooms(arr) {
    const entries = arr.map((diffValue) => {
        const oldValue = diffValue.oldValue;
        const newValue = diffValue.newValue;
        if (!oldValue && !newValue) {
            return `
                <tr>
                    <td colspan="3" style="background-color: #e5e7eb; font-weight: 600;">
                        ${diffValue?._name}
                    </td>
                </tr>
                ${Object.entries(diffValue)
                    .map(([key, val]) => {
                        if (key.startsWith('_')) return '';
                        if (Array.isArray(val)) return renderArray(key, val);
                        return renderRow(key, val);
                    })
                    .join('')}
            `;
        }
        if (!oldValue) {
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #2563eb;">${_t.diff.added()}</p>
                        
                                <p style="margin-top: 0px;">${newValue._name}</p>
                    </td>
                </tr>
            `;
        }
        if (!newValue) {
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #dc2626;">${_t.diff.removed()}</p>
                                <p style="margin-top: 0px;">${oldValue._name}</p>
                    </td>
                </tr>
            `;
        }
    });

    return `
        <table style="width: 100%;">
            <tr>
                <td colspan="3" style="padding: 0.5rem; background-color: #f3f4f6; font-weight: 600;">
                    ${_t.mail.fields.rooms()}
                </td>
            </tr>
            ${entries.join('')}
        </table>
    `;
}

function renderDocuments(arr, options) {
    const entries = arr.map((diffValue) => {
        const oldValue = diffValue.oldValue;
        const newValue = diffValue.newValue;
        if (!oldValue && !newValue) {
            return `
                <tr>
                    <td colspan="3" style="background-color: #e5e7eb; font-weight: 600;">
                        ${diffValue?._name}
                    </td>
                </tr>
                ${Object.entries(diffValue)
                    .map(([key, val]) => {
                        if (key.startsWith('_')) return '';
                        return renderRow(key, val);
                    })
                    .join('')}
            `;
        }
        if (!oldValue) {
            const doc = options.totalDocs.find((el) => el.id === newValue) ?? newValue;
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #2563eb;">${_t.diff.added()}</p>
                        </td>
                </tr>
                <tr>
                    <td colspan="1" style="${headerCellStyle} width: 20%;">
                        ${_t.mail.fields.name()}
                    </td>
                    <td style="${fullWidthCellStyle}">                                            
                        <a href="${doc.src}">
                            ${doc._name ?? doc.name ?? ''}
                        </a>
                    </td>
                </tr>
            `;
        }
        if (!newValue) {
            const doc =
                typeof oldValue === 'string'
                    ? options.totalDocs.find((el) => el.id === oldValue) ??
                      options.diff.documents.find((el) => el._key === oldValue).oldValue
                    : oldValue;
            return `
                <tr style="border: 1px solid #ccc;">
                    <td colspan="3" style="padding: 0.5rem;">
                        <p style="font-weight: bold; color: #dc2626;">${_t.diff.removed()}</p>
                        <table >
                           <tr>
                                <td colspan="1" style="${headerCellStyle} width: 20%; border: none;">
                                    ${_t.mail.fields.name()}:
                                </td>
                                <td style="${fullWidthCellStyle} border: none;">
                                    <a href="${doc.src}">
                                        ${doc._name ?? doc.name ?? ''}
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            `;
        }
    });

    return `<tr>
    <td colspan="3" style="${cellStyle} width: 100%; border: none;">
    <table style="${borderTableStyle} width: 100%;">
    <td colspan="3" style="padding: 0.5rem; background-color: #f3f4f6; font-weight: 600; width: 100%;">
    ${_t.mail.fields.documents()}
    </td>
    ${entries.join('')}
    </table>
    </td>
    </tr>
    `;
}

//////////////////
// PLAN TEMPLATE
/////////////////

function generatePlanTemplateHtml(props) {
    const { name, title, type, template, summaryMode, ...rest } = props;
    const _cols = new Array(templateColspan).fill(0);
    const header = _cols.map((el) => `<th style="width: ${100 / templateColspan};"></th>`).join('');

    let html = `<table style="${tableStyle} padding: 0.5px; width: 100%; ">
        <thead style="max-height: 0px;">
        ${header}
        </thead>`;

    if ((title || type) && !summaryMode) {
        html += `
        <tr style="width: 100%; min-height: 30px; font-weight: 600; color: #374151;">
            <td colspan="${templateColspan}" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                ${title || type?.[0]?.toUpperCase() + type?.slice(1)}
            </td>
        </tr>
    `;
    }

    if (type !== 'suggestion') {
        html += generateMainTemplateHtml(props);
    } else {
        html += generateSuggestionTemplateHtml(props);
    }

    if (type === 'accommodation') {
        html += generateAccommodationTemplateHtml(props);
    } else if (type === 'activity') {
        html += generateActivityTemplateHtml(props);
    } else if (type === 'transfer') {
        html += generateTransferTemplateHtml(props);
    }

    html += '</table>';
    const start = html.indexOf('<t');
    return html.slice(start);
}

function generateMainTemplateHtml(props) {
    const { description, name, price, gallery, roomGallery, currentData } = props;

    const initialGallery = roomGallery ?? gallery;

    let html = '';

    if (initialGallery && initialGallery.length > 0) {
        html += `<tr style="width: 100%;">
            <td colspan="${templateColspan}">
            ${renderImage(initialGallery.find((_) => true))}
            </td>
        </tr>`;
    }
    html += `
    <tr style="width: 100%;">
        ${generateTemplateDiffDataHtml({
            label: _t.mail.fields.title(),
            oldValue: currentData?.name,
            value: name,
            fullWidth: !price
        })}
        ${
            price
                ? generateTemplateDiffDataHtml({
                      label: _t.mail.fields.price(),
                      oldValue: currentData?.price,
                      value: price,
                      fullWidth: !price
                  })
                : ''
        }
    </tr>`;

    if (description) {
        html += `<tr style="width: 100%;">${generateTemplateDiffDataHtml({
            label: _t.mail.fields.description(),
            oldValue: currentData?.description,
            value: description,
            fullWidth: true
        })}</tr>`;
    }

    return html;
}

function generateSuggestionTemplateHtml(props) {
    const { currentData, name, suggestionType, previewMode, defaultText } = props;

    return `
    ${generateTemplateDiffDataHtml({
        label: _t.mail.fields.name(),
        oldValue: currentData?.suggestion?.name,
        value: name,
        fullWidth: true
    })}
    ${generateTemplateDiffDataHtml({
        label: _t.mail.fields.previewMode(),
        oldValue: currentData?.previewMode,
        value: previewMode
    })}
    ${generateTemplateDiffDataHtml({
        label: _t.mail.fields.category(),
        oldValue: currentData?.suggestionType,
        value: suggestionType
    })}
    ${generateTemplateDiffDataHtml({
        label: /* _t.edit.suggestionDefaultText(previewMode) */ '', // TODO diff report: capire cosa scrivere
        oldValue: currentData?.defaultText,
        value: defaultText
    })}
`;
}

function generateAccommodationTemplateHtml(props) {
    const { currentData, category, stars, address, phoneNumber, city, checkInTime, nights } = props;

    let html = '';

    html += `
        ${
            city || address
                ? `<tr style="width: 100%;">
                    ${generateTemplateDiffDataHtml({
                        label: _t.mail.fields.city(),
                        oldValue: currentData?.city,
                        value: city
                    })}
                    ${generateTemplateDiffDataHtml({
                        label: _t.mail.fields.address(),
                        oldValue: currentData?.address,
                        value: address,
                        name: 'address'
                    })}
                </tr>`
                : ''
        }
    ${
        checkInTime || phoneNumber
            ? `<tr style="width: 100%;">
        ${generateTemplateDiffDataHtml({
            label: _t.mail.fields.checkInTime(),
            oldValue: currentData?.checkInTime,
            value: checkInTime || '1'
        })}
            ${generateTemplateDiffDataHtml({
                label: _t.mail.fields.phoneNumber(),
                oldValue: currentData?.phoneNumber,
                value: phoneNumber
            })}
      </tr>`
            : ''
    }
    ${
        nights || stars
            ? `    <tr style="width: 100%;">
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.nights(),
                    oldValue: currentData?.nights,
                    value: nights || '1'
                })}
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.stars(),
                    oldValue: currentData?.stars,
                    value: stars || '0',
                    className: 'width: 100%; min-width: 50%;'
                })}
        </tr>`
            : ''
    }
    ${
        category
            ? `<tr>
    ${generateTemplateDiffDataHtml({
        label: _t.mail.fields.category(),
        oldValue: currentData?.category,
        value: category || '',
        className: 'width: 100%; min-width: 50%;',
        style: 'padding-right: 0;'
    })}
    </tr>`
            : ''
    }
    `;

    html += generateRoomsHtml(props);
    return html;
}

function generateActivityTemplateHtml(props) {
    const { currentData, city, meetingPoint, startTime, duration } = props;

    return `${
        meetingPoint || city
            ? `<tr>
            ${generateTemplateDiffDataHtml({
                label: _t.mail.fields.meetingPoint(),
                oldValue: currentData?.meetingPoint,
                value: meetingPoint
            })}
            ${generateTemplateDiffDataHtml({
                label: _t.mail.fields.city(),
                oldValue: currentData?.city,
                value: city
            })}
        </tr>`
            : ''
    }
        ${
            startTime || duration
                ? `<tr>
               ${generateTemplateDiffDataHtml({
                   label: _t.mail.fields.startTime(),
                   oldValue: currentData?.startTime,
                   value: startTime
               })}
              ${generateTemplateDiffDataHtml({
                  label: _t.mail.fields.duration(),
                  oldValue: currentData?.duration,
                  value: duration || '0'
              })}
          </tr>`
                : ''
        }
    `;
}

function generateTransferTemplateHtml(props) {
    const {
        currentData,
        transportation,
        vehicleNumber,
        departureTime,
        arrivalTime,
        arrival,
        departure,
        phoneNumber,
        company,
        pax
    } = props;

    let html = `<tr style="width: 100%;">${generateTemplateDiffDataHtml({
        label: _t.mail.fields.departure(),
        value: departure
    })}
        ${generateTemplateDiffDataHtml({
            label: _t.mail.fields.arrival(),
            value: arrival
        })}
        </tr>${
            departureTime || arrivalTime
                ? `<tr>
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.departureTime(),
                    oldValue: currentData?.departureTime,
                    value: departureTime
                })}
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.arrivalTime(),
                    oldValue: currentData?.arrivalTime,
                    value: arrivalTime
                })}
                    </tr>`
                : ``
        }
        ${
            transportation
                ? ` <tr>
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.transferType(),
                    oldValue: currentData?.transportation,
                    value: transportation
                })}
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.vehicleNumber(),
                    oldValue: currentData?.vehicleNumber,
                    value: vehicleNumber
                })}
                    </tr>`
                : ''
        }
        ${
            transportation === 'O'
                ? `<tr>
                ${(html += generateTemplateDiffDataHtml({
                    label: _t.mail.fields.phoneNumber(),
                    oldValue: currentData?.phoneNumber,
                    value: phoneNumber
                }))}
                    </tr>
                  `
                : ''
        }
        ${
            company || pax
                ? `<tr>
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.company(),
                    oldValue: currentData?.company,
                    value: company
                })}
                ${generateTemplateDiffDataHtml({
                    label: _t.mail.fields.passengers(),
                    oldValue: currentData?.pax,
                    value: pax
                })}
                    </tr>`
                : ''
        }
    `;

    return html;
}

function generateTemplateDiffDataHtml(props) {
    const { label, oldValue, value, className, labelClassName, valueClassName, fullWidth } = props;
    if (value === null || value === undefined) return '';

    if (oldValue === value || oldValue === null || oldValue === undefined) {
        return generateTemplateDataHtml({
            label,
            value,
            className,
            labelClassName,
            valueClassName,
            fullWidth
        });
    }

    const oldDangerousValue = oldValue || _t.global.emptyString();
    const dangerousValue = value || _t.global.emptyString();
    return `
        <tr style="width: 100%; padding: 0.25rem 0.5rem; background-color: #f0f9ff; border: 1px solid #bfdbfe; border-radius: 0.5rem; ${className}">
            <td style="${callBaseDiffDataStyle} color: #374151; font-weight: 600; ${labelClassName}">${label}</td>
            <td style="${callBaseDiffDataStyle} text-decoration: underline;">${_t.mail.fields.oldValue()}</td>
            <td style="${callBaseDiffDataStyle} margin-bottom: 0.5rem; ${valueClassName}">${oldDangerousValue}</td>
            <td style="${callBaseDiffDataStyle} text-decoration: underline;">${_t.mail.fields.newValue()}</td>
            <td style="${callBaseDiffDataStyle} ${valueClassName}">${dangerousValue}</td>
        </tr>
    `;
}

function generateTemplateDataHtml(props) {
    const { label, value, className, labelClassName, valueClassName, fullWidth } = props;
    if (!value) return '';

    return ` <td colspan="${fullWidth ? templateColspan : templateColspan / 2}" style="width: ${
        fullWidth ? '100%' : '50%'
    }">
    <p style="color: #374151; font-weight: 600; ${labelClassName}">${label}</p>
    </p>
    <p style="${valueClassName}">${value}
    </p>
    </td>`;
}

function generateRoomsHtml(props) {
    const { currentData, rooms } = props;
    if (!rooms || !rooms.length) return '';
    let html = `<tr>
    <td colspan="${templateColspan}">`;

    for (let index = 0; index < rooms.length; index++) {
        const room = rooms[index];
        const currentRoom = currentData?.rooms?.find((r) => r.importId === room.importId);
        html += generateRoomTemplateHtml({
            room,
            tempIndex: index + 1,
            currentRoom,
            ...props
        });
    }

    html += `</td></tr>`;
    return html;
}

function generateRoomTemplateHtml(props) {
    const { currentRoom, tempIndex, room, onEdit, dayId, planId } = props;

    return `
    <table style="${borderTableStyle} width: 100%; box-sizing: border-box;">
        <tr style="box-sizing: border-box;">
            <td colspan="${templateColspan}" style="${headerCellStyle} box-sizing: border-box;">${
        room.name || `Room ${tempIndex}`
    }</td>
        </tr>
            ${generateMainTemplateHtml(room)}
            <tr>
            ${generateTemplateDiffDataHtml({
                label: _t.mail.fields.pax(),
                oldValue: currentRoom?.pax,
                value: room.pax,
                name: 'pax',
                type: 'number'
            })}
            </tr>
    </table>
`;
}
